import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ReincorporationRegisterView from './ReincorporationRegisterView';
import { Creators as detailActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as programByCampusActions } from '../../../../../../../domain/useCases/procedures/reincorporation/programByCampusUseCase';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/reincorporation/registerReincorporationUseCase';
import useProfile from '@/presentation/hooks/useProfile';

const ReincorporationRegisterViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // User is virtual
  const [isVirtual, setIsVirtual] = useState<boolean>(false);
  const [isVirtualChange, setIsVirtualChange] = useState<boolean>(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [selectedPeriod, setSelectedPeriod] = useState<any>(null);
  const [showConfirm, setShowConfirm] = useState(false);

  // selectors
  const { procedure: procedureInfo } = useSelector(
    (state: any) => state.procedureInformation
  );

  useEffect(() => {
    if (!procedureInfo) {
      history.push('/tramites');
    }
  }, [procedureInfo]);

  const studentProfile = useProfile();

  const {
    isLoading: isProcessingRegister,
    data: requestId,
    error: registerHasError
  } = useSelector((state: any) => state.registerReincorporation);

  const { data: profileInfo } = useSelector((state: any) => state.profile);

  const { isLoading: isProcessingProgramByCampus, data: programByCampus } =
    useSelector((state: any) => state.programByCampus);

  // useEffects
  useEffect(() => {
    if (!procedureInfo)
      dispatch(procedureActions.getProcedureInformation(1033));
  }, [procedureInfo]);

  useEffect(() => {
    if (procedureInfo) {
      const firstPeriod = procedureInfo.detail.periodApplied[0];
      const virtual = procedureInfo.detail.currentAcademicData.campus.id;
      setIsVirtual(virtual === 'VIRT');
      setIsVirtualChange(virtual !== 'VIRT');
      setSelectedPeriod({ value: firstPeriod?.id, name: firstPeriod?.name });
    }
  }, [procedureInfo]);

  useEffect(() => {
    if (requestId > 0) {
      dispatch(detailActions.getStudentProcedureStatus(1033, requestId));
      history.push(
        '/tramites/autogestionables/solicitud/reincorporacion/progreso'
      );
    }
  }, [requestId]);

  const getProgramByCampus = (campusId: string) => {
    dispatch(
      programByCampusActions.programByCampus(campusId, selectedPeriod.value)
    );
  };

  const handlerRegisterClear = () => {
    dispatch(registerActions.registerReincorporationClear());
  };

  const handlerChangePeriod = (element: any) => {
    setSelectedPeriod(element);
  };

  const handlerRegisterRequest = () => {
    setShowConfirm(true);
  };

  const handlerRegisterWithoutChanges = () => {
    const data = {
      procedureId: 1033,
      newPeriod: selectedPeriod.value,
      requiresPayment: false,
      campusId: procedureInfo?.detail?.currentAcademicData?.campus?.id,
      careerId: procedureInfo?.detail?.currentAcademicData?.program?.id,
      modalityId:
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityCode,
      newCampusId: procedureInfo?.detail?.currentAcademicData?.campus?.id,
      newCampusDescription:
        procedureInfo?.detail?.currentAcademicData?.campus?.name,
      newCareerId: procedureInfo?.detail?.currentAcademicData?.program?.id,
      newCareerDescription:
        procedureInfo?.detail?.currentAcademicData?.program?.name,
      newModalityId:
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityCode,
      newModalityDescription:
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityName,
      reincorporationType: '0',
      academicPlan:
        studentProfile.getValue('career') === 'PPE'
          ? procedureInfo?.detail?.currentAcademicData?.modality?.name
          : studentProfile.getValue('plan'),
      newAcadCareer: studentProfile.getValue('career'),
      codProgCM: '',
      codPlanCM: '',
      acadCareerCM: ''
    };
    dispatch(registerActions.registerReincorporation(data));
  };

  const handlerRegisterWithChanges = (
    params: any = {
      newModalityId: '',
      newModalityDescription: '',
      newCampusId: '',
      newCampusDescription: '',
      newCareerId: '',
      newCareerDescription: '',
      requiresPayment: false,
      reincorporationType: '0',
      newPlan: '',
      newAcadCareer: ''
    }
  ) => {
    const data = {
      procedureId: 1033,
      newPeriod: selectedPeriod.value,
      requiresPayment: params.requiresPayment,
      campusId: procedureInfo?.detail?.currentAcademicData?.campus?.id,
      careerId: procedureInfo?.detail?.currentAcademicData?.program?.id,
      modalityId:
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityCode,

      newCampusId:
        params.newCampusId ||
        procedureInfo?.detail?.currentAcademicData?.campus?.id,
      newCampusDescription:
        params.newCampusDescription ||
        procedureInfo?.detail?.currentAcademicData?.campus?.name,

      newCareerId:
        params.newCareerId ||
        procedureInfo?.detail?.currentAcademicData?.grouping?.id,
      newCareerDescription:
        params.newCareerDescription ||
        procedureInfo?.detail?.currentAcademicData?.grouping?.name,

      newModalityId:
        params.newModalityId ||
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityCode,
      newModalityDescription:
        params.newModalityDescription ||
        procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityName,
      reincorporationType: params.reincorporationType,
      academicPlan: params.newPlan, // studentProfile.getValue('plan')
      newAcadCareer: params.newAcadCareer,
      codProgCM: params.codProgCM,
      codPlanCM: params.codPlanCM,
      acadCareerCM: params.acadCareerCM
    };
    dispatch(registerActions.registerReincorporation(data));
  };

  const handlerBackButton = () => {
    history.goBack();
  };

  // if (procedureInfo || isLoading)
  return (
    <ReincorporationRegisterView
      programByCampus={programByCampus}
      isVirtual={isVirtual}
      setIsVirtualChange={setIsVirtualChange}
      isVirtualChange={isVirtualChange}
      isProcessingProgramByCampus={isProcessingProgramByCampus}
      procedureInfo={procedureInfo}
      profileInfo={profileInfo}
      selectedPeriod={selectedPeriod}
      onChangePeriod={handlerChangePeriod}
      onRegisterRequest={handlerRegisterRequest}
      getProgramByCampus={getProgramByCampus}
      confirm={{ showConfirm, setShowConfirm }}
      step={{ currentStep, setCurrentStep }}
      isProcessingRegister={isProcessingRegister}
      error={{
        showError: registerHasError,
        setShowError: handlerRegisterClear
      }}
      registerWithoutChanges={handlerRegisterWithoutChanges}
      registerWithChanges={handlerRegisterWithChanges}
      onBackButton={handlerBackButton}
      isPPE={useProfile().getValue('career') === 'PPE'}
    />
  );
};

export default ReincorporationRegisterViewController;
